import { render, staticRenderFns } from "./JacRegionEdit.vue?vue&type=template&id=15029908&scoped=true"
import script from "./JacRegionEdit.vue?vue&type=script&lang=js"
export * from "./JacRegionEdit.vue?vue&type=script&lang=js"
import style0 from "./JacRegionEdit.vue?vue&type=style&index=0&id=15029908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15029908",
  null
  
)

export default component.exports